<template>
  <div class="bonus-wrapper">
    <!-- Bonus-Popup -->
    <vs-popup
      :active.sync="showPopup"
      :title="popupTitle"
      class="bonus-popup"
      ref="popup"
    >
      <div class="bonus-detail">
        <template v-if="isEditing">
          <!-- OBERE 3 SPALTEN: Kategorie/Titel/Zeitraum - Bild - Status/Erstellt/Geändert -->
          <vs-row vs-w="12">
            <!-- SPALTE 1 -->
            <vs-col vs-w="12" vs-md="12" vs-lg="4" class="p-3 column-scroll">
              <div class="input-with-label spec-input">
                <label>Kategorie*</label>
                <vs-select
                  v-model="form.categories"
                  placeholder="Bitte wählen"
                  class="inputx"
                >
                  <vs-select-item
                    v-for="cat in categories"
                    :key="cat"
                    :value="cat"
                    :text="cat"
                  />
                </vs-select>
              </div>

              <div class="mt-4 spec-input">
                <vs-input
                  v-model="form.title"
                  placeholder="Überschrift*"
                  label-placeholder="Überschrift*"
                  class="inputx"
                  maxlength="50"
                />
              </div>
              <div class="mt-4 spec-input">
                <vs-input
                  v-model="form.offer"
                  class="inputx"
                  placeholder="Angebot*"
                  label-placeholder="Angebot*"
                  maxlength="100"
                />
              </div>

              <div class="input-with-label spec-input">
                <label>Zeitraum von*</label>
                <div class="row-two-columns">
                  <vs-input type="date" v-model="dateFromDate" />
                  <vs-input
                    type="time"
                    v-model="dateFromTime"
                    icon="access_time"
                    icon-pack="material-icons"
                    icon-after
                  />
                </div>
              </div>

              <div class="input-with-label spec-input">
                <label>Zeitraum bis*</label>
                <div class="row-two-columns">
                  <vs-input type="date" v-model="dateToDate" />
                  <vs-input
                    type="time"
                    v-model="dateToTime"
                    icon="access_time"
                    icon-pack="material-icons"
                    icon-after
                  />
                </div>
              </div>
            </vs-col>

            <!-- SPALTE 2 -->
            <vs-col vs-w="12" vs-md="12" vs-lg="4" class="p-3">
              <!-- Cropper nur rendern, wenn showCropper true -->
              <div class="mt-2">
                <cropUpload
                  v-show="showCropper"
                  field="img"
                  @crop-success="cropSuccess"
                  @crop-upload-success="cropUploadSuccess"
                  @crop-upload-fail="cropUploadFail"
                  @crop-delete="cropDelete"
                  @crop-off="showCropper = false"
                  v-model="showCropper"
                  :width="300"
                  :height="300"
                  :langExt="langExt2"
                  noCircle
                  img-format="png"
                  ref="uploader"
                />
              </div>

              <!-- Vorschau -->
              <div class="img-container mt-4" v-if="previewImage">
                <img
                  class="passport-img"
                  :src="previewImage"
                  alt="Bonus Logo"
                  @click="openCropper"
                />
                <button class="img-close" @click="removeImage">×</button>
              </div>

              <!-- Upload-Bereich -->
              <div class="img-container mt-2" v-else @click="openCropper">
                <img
                  :src="previewImage || '/icons/upload-photo.svg'"
                  alt="Upload Bild"
                />
              </div>
            </vs-col>

            <!-- SPALTE 3 -->
            <vs-col vs-w="12" vs-md="12" vs-lg="4" class="p-3 column-scroll">
              <div class="input-with-label spec-input mb-1">
                <label>Status*</label>
                <vs-select v-model="form.status" class="full-width">
                  <vs-select-item value="paused" text="Inaktiv" />
                  <vs-select-item value="active" text="Aktiv" />
                  <vs-select-item value="archived" text="Archiviert" />
                </vs-select>
              </div>
              <div class="input-with-label">
                <label for="createAt" style="color: #d0d0d0;"
                  >Erstellt am</label
                >
                <vs-input
                  class="readonly full-width spec-input"
                  type="date"
                  v-model="form.created_at"
                  disabled
                />
              </div>
              <div class="input-with-label">
                <label for="changeAt" style="color: #d0d0d0;"
                  >Geändert am</label
                >
                <vs-input
                  class="readonly full-width spec-input"
                  :type="form.updated_at ? 'date' : 'text'"
                  :value="form.updated_at ? form.updated_at : '--.--.----'"
                  disabled
                />
              </div>
            </vs-col>
          </vs-row>

          <!-- NEUE 2-SPALTEN-STRUKTUR -->
          <vs-row vs-w="12">
            <!-- Linke Spalte -->
            <vs-col vs-w="12" vs-md="12" vs-lg="6" class="p-2">
              <!-- Organisationen -->
              <div class="input-with-label mb-4" ref="orgContainer">
                <label class="label">Organisationen*</label>
                <div class="org-input-field">
                  <div
                    class="chips-container"
                    :style="{ maxHeight: showAllOrgs ? 'none' : '30px' }"
                  >
                    <template v-if="!showAllOrgs">
                      <span
                        v-for="orgId in visibleOrgs"
                        :key="orgId"
                        class="chip"
                      >
                        {{ getOrgName(orgId) }}
                        <button
                          class="chip-close"
                          @click="removeOrganization(orgId)"
                        >
                          ×
                        </button>
                      </span>
                      <span
                        v-if="form.organizations.length > maxVisibleOrgs"
                        class="more-chip"
                        @click="toggleShowAllOrgs"
                      >
                        {{
                          showAllOrgs
                            ? "Weniger anzeigen"
                            : `+${form.organizations.length -
                                maxVisibleOrgs} mehr`
                        }}
                      </span>
                    </template>

                    <template v-else>
                      <span
                        class="chip"
                        v-for="orgId in form.organizations"
                        :key="orgId"
                      >
                        {{ getOrgName(orgId) }}
                        <button
                          class="chip-close"
                          @click="removeOrganization(orgId)"
                        >
                          ×
                        </button>
                      </span>
                      <span class="more-chip" @click="showAllOrgs = false">
                        Weniger anzeigen
                      </span>
                    </template>
                  </div>
                  <vs-button
                    class="org-add-btn"
                    icon="add"
                    size="small"
                    @click="toggleOrgPopup"
                  />

                  <!-- KLEINES POPOVER -->
                  <div v-if="orgPopupActive" class="org-popover">
                    <div class="mb">
                      <vs-checkbox v-model="selectAll" @change="toggleAll">
                        <span style="color: black;font-size: 1rem;"
                          >Alle auswählen</span
                        >
                      </vs-checkbox>
                    </div>
                    <div
                      v-for="org in allOrganizationsList"
                      :key="org.id"
                      class=" org-list-item"
                    >
                      <vs-checkbox
                        :vs-value="org.id"
                        v-model="tempSelectedOrgs"
                      >
                        <span style="color: black;font-size: 1rem;">{{
                          org.name
                        }}</span>
                      </vs-checkbox>
                    </div>
                    <div class="popover-footer">
                      <vs-button size="small" @click="applyOrganizations"
                        >Übernehmen</vs-button
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class=" spec-input mb-4">
                <vs-input
                  v-model="form.name1"
                  label-placeholder="Anbieter Name-1*"
                  class="inputx"
                  maxlength="35"
                />
              </div>

              <div class="spec-input">
                <vs-input
                  v-model="form.name2"
                  label-placeholder="Anbieter Name-2"
                  class="inputx"
                  maxlength="35"
                />
              </div>
              <div class="input-with-label" style="margin-bottom: 23px;">
                <label>Beschreibung*</label>
                <vs-textarea
                  ref="desc"
                  v-model="form.description"
                  class="full-width border"
                  :rows="5"
                />
              </div>
              <div class="mb-4 spec-input">
                <vs-input
                  v-model="form.code"
                  class="inputx"
                  placeholder="Vorteilscode"
                  label-placeholder="Vorteilscode"
                  maxlength="20"
                />
              </div>
            </vs-col>

            <!-- Rechte Spalte -->
            <vs-col
              vs-w="12"
              vs-md="12"
              vs-lg="6"
              class="p-2"
              style="margin-top:1.5px;"
            >
              <div class="spec-input mb-4">
                <vs-input
                  v-model="form.street"
                  label-placeholder="Straße"
                  class="inputx full-width"
                />
              </div>
              <div class="spec-input adress_input">
                <vs-input
                  v-model="form.zip_code"
                  label-placeholder="PLZ"
                  class="inputx"
                  @keypress="allowOnlyNumbers"
                  style="max-width: 120px; margin-right: 15px;"
                />
                <vs-input
                  v-model="form.city"
                  label-placeholder="Ort"
                  class="inputx"
                />
              </div>
              <div class="mb-4 spec-input">
                <vs-input
                  v-model="form.phone"
                  label-placeholder="Telefon"
                  class="inputx full-width"
                  @keypress="allowPhoneChars"
                />
              </div>
              <div class="spec-input mb-4">
                <vs-input
                  v-model="form.email"
                  label-placeholder="E-Mail"
                  class="inputx full-width"
                />
              </div>
              <div class="spec-input mb-4">
                <vs-input
                  v-model="form.website"
                  label-placeholder="Webseite"
                  class="inputx full-width"
                />
              </div>
              <div class="spec-input mb-4">
                <vs-input
                  v-model="form.shop"
                  label-placeholder="Online-Shop"
                  class="inputx full-width"
                />
              </div>
            </vs-col>
          </vs-row>

          <!-- Buttons -->
          <div class="popup-footer">
            <div class="left">
              <!-- Löschen nur sichtbar, wenn der Bonus bereits existiert -->
              <vs-button
                v-if="form.id"
                color="danger"
                icon="delete"
                @click="deleteBonus"
              >
                Löschen
              </vs-button>
            </div>

            <div class="right">
              <!-- Anlegen / Speichern -->
              <vs-button
                color="primary"
                @click="submitForm"
                style="margin-right: 5px;"
                icon="done"
              >
                {{ form.id ? "Speichern" : "Anlegen" }}
              </vs-button>

              <!-- Abbrechen -->
              <vs-button
                @click="cancelEdit"
                style="margin-left: 5px;"
                icon="close"
              >
                Abbrechen
              </vs-button>
            </div>
          </div>
        </template>

        <!-- Detail Ansicht -->
        <template v-else>
          <div class="bonus-detail-view">
            <!-- Kachel 1: Überschrift + Bild -->
            <div class="bonus-card">
              <div class="bonus-header">
                <div class="header-left">
                  <h2 class="bonus-title">{{ bonus.headline_text }}</h2>
                  <p class="bonus-offer">{{ bonus.discount_text }}</p>
                </div>
                <div class="header-right">
                  <img
                    :src="bonus.previewImage"
                    alt="Bonus Bild"
                    class="bonus-image"
                  />
                </div>
              </div>
            </div>

            <!-- Kachel 2: Rest -->
            <div class="bonus-card">
              <div class="chips-row">
                <span class="chip status" :class="bonus.status">{{
                  getStatusLabel(bonus.status)
                }}</span>
                <span class="chip category">{{
                  Array.isArray(bonus.categories)
                    ? bonus.categories[0]
                    : bonus.categories
                }}</span>
              </div>
              <!-- Zeitraum -->
              <div class="meta-item period-horizontal">
                <strong style="color: #005B9B;">Zeitraum</strong>
                <div class="period-row-horizontal">
                  <div class="period-item">
                    <span class="label">Von:</span>
                    <span
                      class="value"
                      v-html="formatDate(bonus.start_at)"
                    ></span>
                  </div>
                  <div class="period-item">
                    <span class="label">Bis:</span>
                    <span
                      class="value"
                      v-html="formatDate(bonus.end_at)"
                    ></span>
                  </div>
                </div>
              </div>

              <!-- Organisationen -->
              <div class="meta-item">
                <strong style="color: #005B9B;">Organisationen</strong>
                <div class="chips">
                  <span
                    v-for="orgId in this.form.organizations"
                    :key="orgId"
                    class="chip"
                  >
                    {{ getOrgName(orgId) }}
                  </span>
                </div>
              </div>

              <!-- Beschreibung -->
              <div>
                <strong style="color: #005B9B;">Beschreibung</strong>
                <p style="margin: 0">{{ bonus.description_text }}</p>
              </div>

              <!-- Anbieterinformationen -->
              <div>
                <strong style="color: #005B9B;">Anbieterinformationen</strong>
                <ul class="anbieter-list">
                  <li>
                    <i class="material-icons">person</i>
                    {{
                      bonus.address && bonus.address.name
                        ? bonus.address.name
                        : ""
                    }}
                    <span v-if="bonus.address.name && bonus.address.additional">
                      |
                    </span>
                    {{ bonus.address.name ? bonus.address.additional : "" }}
                  </li>
                  <li>
                    <i class="material-icons">place</i>
                    {{
                      bonus.address && bonus.address.street_address
                        ? bonus.address.street_address
                        : ""
                    }}
                    <span
                      v-if="
                        bonus.address &&
                          bonus.address.street_address &&
                          (bonus.address.zip_code || bonus.address.city)
                      "
                      >,
                    </span>
                    {{
                      bonus.address && bonus.address.zip_code
                        ? bonus.address.zip_code
                        : ""
                    }}
                    {{
                      bonus.address && bonus.address.city
                        ? bonus.address.city
                        : ""
                    }}
                  </li>
                  <li>
                    <i class="material-icons">language</i>
                    <span v-if="bonus.website_url">
                      <a
                        :href="bonus.website_url"
                        target="_blank"
                        rel="noopener"
                      >
                        {{ bonus.website_url }}
                      </a>
                    </span>
                  </li>
                  <li>
                    <i class="material-icons">shopping_cart</i>
                    <span v-if="bonus.shop_url">
                      <a :href="bonus.shop_url" target="_blank" rel="noopener">
                        {{ bonus.shop_url }}
                      </a>
                    </span>
                  </li>
                </ul>
              </div>

              <!-- Vorteilscode -->
              <div>
                <strong style="color: #005B9B;">Vorteilscode</strong>
                <ul class="anbieter-list">
                  <li>
                    <i class="material-icons">confirmation_number</i>
                    {{ bonus.code ? bonus.code : "" }}
                  </li>
                </ul>
              </div>
            </div>

            <!-- Footer -->
            <div class="bonus-footer">
              <div class="action-buttons">
                <vs-button @click="handleClose" icon="cancel"
                  >Schließen</vs-button
                >
                <vs-button icon="edit" color="primary" @click="startEditing"
                  >Bearbeiten</vs-button
                >
              </div>
            </div>
          </div>
        </template>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import CropUpload from "@/plugins/mpcropupload/upload2.vue";
import bonus from "../../store/modules/bonus";
import core from "../../store/modules/core";

export default {
  name: "BonusDetailPopup",
  props: {
    active: Boolean,
    bonus: Object,
    showPopup: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CropUpload,
  },
  data() {
    const now = new Date();
    const pad = (n) => String(n).padStart(2, "0");

    const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
      now.getDate(),
    )}`;
    const endOfYear = `${now.getFullYear()}-12-31`;
    return {
      isEditing: !this.bonus || !this.bonus.id,
      form: this.getEmptyForm(),
      previewImage: null,
      showCropper: false,
      cropperKey: 0,
      langExt2: {
        titel: "Bonusbild bearbeiten",
        hint: "Klicken um Foto auszuwählen oder Foto direkt hierher ablegen",
        loading: "Wird hochgeladen...",
        noSupported:
          "Ihr Browser wird nicht unterstützt. Bitte verwenden Sie IE10+ oder einen anderen Browser.",
        uploadMessage:
          "Mit dem Upload bestätigen Sie, im Besitz der Nutzungsrechte für das Foto zu sein.",
        uploadImgSize:
          "[Nur JPG-, PNG- oder SVG-Datei mit 300 x 300 Pixel und max. 1 MB Dateigröße]",
        success: "Erfolgreich hochgeladen",
        fail: "Hochladen fehlgeschlagen",
        preview: "Vorschau",
        btn: {
          off: "Abbrechen",
          close: "Schliessen",
          back: "Zurück",
          save: "Speichern",
          delete: "Löschen",
        },
        error: {
          onlyImg: "Nur Passfoto im Format: JPG,JPEG,PNG,GIF,SVG oder BMP",
          outOfSize: "Passfoto zu groß, Maximum: ",
          lowestPx: "Passfoto zu klein, Minimum: ",
        },
      },
      categories: [
        "Shopping",
        "Kultur",
        "Mobilität",
        "Multimedia",
        "Gesundheit",
        "Einrichtung",
        "Gastronomie",
        "Dienstleistung",
        "Sonstiges",
      ],
      statusMap: {
        archived: "Archiviert",
        paused: "Inaktiv",
        active: "Aktiv",
      },

      dateFromDate: today,
      dateFromTime: "00:00",
      dateToDate: endOfYear,
      dateToTime: "00:00",

      // --- Organisations Popup state ---
      orgPopupActive: false,
      tempSelectedOrgs: [],
      selectAll: false,

      // --- Anzeige für mehr/weniger Organisationen ---
      maxVisibleOrgs: 3,
      showAllOrgs: false,
      internalShowPopup: this.showPopup,
    };
  },
  computed: {
    popupTitle() {
      if (!this.bonus || !this.bonus.id) {
        return "Bonus anlegen"; // Neuer Bonus
      } else if (this.isEditing) {
        return "Bonus bearbeiten"; // Bestehender Bonus wird bearbeitet
      } else {
        return "Bonusdetails"; // Bestehender Bonus wird nur angezeigt
      }
    },

    allOrganizationsList() {
      return this.$store.getters["organization/getOrganizations"] || [];
    },

    loadBonusOrganisations() {
      return this.$store.getters["bonus/loadBonusOrganisations"];
    },

    user() {
      return this.$store.getters["auth/getUser"];
    },

    visibleOrgs() {
      if (this.showAllOrgs) return this.form.organizations;
      return this.form.organizations.slice(0, this.maxVisibleOrgs);
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  watch: {
    bonus: {
      immediate: true,
      handler: async function(newVal) {
        // Leeres Formular für neuen Bonus
        if (!newVal || !newVal.id) {
          const { today, endOfYear } = this.getDefaultDates();
          this.isEditing = true;
          this.form = this.getEmptyForm();
          this.previewImage = null;
          this.dateFromDate = today;
          this.dateFromTime = "00:00";
          this.dateToDate = endOfYear;
          this.dateToTime = "00:00";
        } else {
          // Bestehender Bonus
          this.isEditing = false;
          this.populateForm(newVal);
        }
      },
    },
    showPopup(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const content = this.$refs.popup.$el.querySelector(
            ".vs-popup--content",
          );
          if (content) content.scrollTop = 0;
        });
      }
    },
  },

  methods: {
    getDefaultDates() {
      const now = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      return {
        today: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
          now.getDate(),
        )}`,
        endOfYear: `${now.getFullYear()}-12-31`,
      };
    },
    startEditing() {
      this.isEditing = true;
      this.populateForm(this.bonus); // Bestehende Daten laden
    },
    populateForm(bonusData) {
      if (!bonusData) return;

      this.form.id = bonusData.id || null;
      this.form.title = bonusData.headline_text || "";
      this.form.offer = bonusData.discount_text || "";
      this.form.description = bonusData.description_text || "";
      this.form.email = bonusData.email || "";
      this.form.code = bonusData.code || "";
      this.form.name1 = bonusData.address?.name || "";
      this.form.name2 = bonusData.address?.additional || "";
      this.form.phone = bonusData.phone_number || "";
      this.form.website = bonusData.website_url || "";
      this.form.shop = bonusData.shop_url || "";
      this.form.status = bonusData.status;
      this.form.created_at = bonusData.created_at?.split("T")[0] || "";
      this.form.updated_at = bonusData.updated_at?.split("T")[0] || "";
      this.form.street = bonusData.address?.street_address || "";
      this.form.zip_code = bonusData.address?.zip_code || "";
      this.form.city = bonusData.address?.city || "";
      this.form.categories =
        Array.isArray(bonusData.categories) && bonusData.categories.length
          ? bonusData.categories[0]
          : "";

      // Organisationen
      this.$store
        .dispatch("bonus/loadBonusOrganisations", bonusData.id)
        .then((orgs) => {
          this.form.organizations = orgs.map((o) => o.organisation_id);
        });

      // Zeitraum
      if (bonusData.start_at) {
        [this.dateFromDate, this.dateFromTime] = bonusData.start_at.split("T");
        this.dateFromTime = this.dateFromTime?.slice(0, 5) || "00:00";
      }
      if (bonusData.end_at) {
        [this.dateToDate, this.dateToTime] = bonusData.end_at.split("T");
        this.dateToTime = this.dateToTime?.slice(0, 5) || "00:00";
      }

      // Bild
      if (bonusData.image_id) {
        this.form.image_id = bonusData.image_id;
        this.loadImagePreview(bonusData.image_id);
      } else {
        this.form.image_id = null;
        this.previewImage = null;
      }
    },

    getEmptyForm() {
      return {
        id: null,
        categories: "",
        organizations: [],
        status: "paused",
        title: "",
        offer: "",
        code: "",
        description: "",
        name1: "",
        name2: "",
        street: this.bonus?.address?.street || "",
        zip_code: this.bonus?.address?.zip_code || "",
        city: this.bonus?.address?.city || "",
        phone: this.bonus?.phone || "",
        email: this.bonus?.email || "",
        website: this.bonus?.website || "",
        shop: this.bonus?.shop || "",
        dateFrom: "",
        dateTo: "",
        image_id: null,
        created_at: null,
        createdBy: null,
        updated_at: null,
        updatedBy: null,
        period: "",
      };
    },
    getStatusLabel(status) {
      return this.statusMap[status] || status;
    },
    tempSelectedOrgs(newVal) {
      // Wenn alle ausgewählt sind, selectAll = true, sonst false
      this.selectAll = newVal.length === this.allOrganizationsList.length;
    },
    allowPhoneChars(event) {
      const allowed = /[0-9+\-()\s]/; // nur Zahlen, +, -, (, ), Leerzeichen
      if (!allowed.test(event.key)) {
        event.preventDefault(); // verhindert das Tippen unerlaubter Zeichen
      }
    },
    allowOnlyNumbers(event) {
      const allowed = /[0-9]/; // nur Zahlen erlaubt
      if (!allowed.test(event.key)) {
        event.preventDefault(); // verhindert alles andere
      }
    },
    formatDate(dateString) {
      if (!dateString) return "";

      // dateString ist ISO: "2025-09-25T00:00"
      const [datePart, timePart] = dateString.split("T");
      const [year, month, day] = datePart.split("-").map(Number);
      const [hours, minutes] = timePart
        ? timePart.split(":").map(Number)
        : [0, 0];

      // lokale Zeit ohne Zeitzonenverschiebung
      const dayStr = ("0" + day).slice(-2);
      const monthStr = ("0" + month).slice(-2);
      const yearStr = year;
      const hoursStr = ("0" + hours).slice(-2);
      const minutesStr = ("0" + minutes).slice(-2);

      return `${dayStr}.${monthStr}.${yearStr}&nbsp;&nbsp;${hoursStr}:${minutesStr} Uhr`;
    },

    imageUrl(id) {
      return id ? `https://localhost:8888/api/v1/images/${id}` : "";
    },

    handleClickOutside(e) {
      if (
        this.orgPopupActive &&
        this.$refs.orgContainer &&
        !this.$refs.orgContainer.contains(e.target)
      ) {
        this.orgPopupActive = false;
      }
    },
    selectImage() {
      this.$refs.fileInput.click();
    },
    onFilePicked(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result; // Vorschau
        };
        reader.readAsDataURL(file);

        // ID wird erst nach Upload gesetzt
        this.form.image_id = null;
      }
    },

    openCropper() {
      this.showCropper = true;
    },
    // wenn Cropping erfolgreich
    async cropSuccess(imgDataUrl) {
      this.previewImage = imgDataUrl; // Vorschau bleibt
      this.showCropper = false;

      try {
        // Base64 extrahieren
        const base64 = imgDataUrl.split(",")[1];

        // JSON-Payload erstellen
        const response = await this.$store.dispatch("core/createImage", base64);

        if (response && response.data && response.data.id) {
          this.form.image_id = response.data.id; // ID fürs Formular speichern
          this.$vs.notify({
            color: "success",
            title: "Bild erfolgreich hochgeladen",
          });
        } else {
          this.form.image_id = null;
          this.$vs.notify({
            color: "warning",
            title: "Bild hochgeladen, aber keine ID zurückbekommen",
          });
        }
      } catch (err) {
        this.form.image_id = null;
        this.$vs.notify({
          color: "danger",
          title: "Bild-Upload fehlgeschlagen",
          text: err.message || "",
        });
      }
    },

    // wenn Upload erfolgreich
    cropUploadSuccess(jsonData, field) {},

    // wenn Upload fehlschlägt
    cropUploadFail(status) {
      this.$vs.notify({
        title: "Upload fehlgeschlagen",
        text: `Fehler beim Upload (${status})`,
        color: "danger",
      });
    },
    // wenn Bild gelöscht wird
    cropDelete() {
      this.removeImage();
    },
    async loadImagePreview(id) {
      if (!id) return;
      try {
        const base64 = await this.$store.dispatch("core/getImage64", id);
        if (base64) {
          this.previewImage = `data:image/png;base64,${base64}`;
        } else {
          this.previewImage = "/icons/Photo.svg"; // Fallback
        }
      } catch (err) {
        this.previewImage = "/icons/Photo.svg"; // Fallback
      }
    },
    // eigenes Entfernen-Button
    async removeImage() {
      if (this.form.image_id) {
        await this.$store.dispatch("core/deleteImage", this.form.image_id);
        this.form.image_id = null;
      }
      this.previewImage = null;
      this.showCropper = false;
    },
    imagePreviewUrl() {
      return this.previewImage ? this.previewImage : "/icons/Photo.svg";
    },

    validateForm() {
      if (!this.dateFromDate || !this.dateToDate) {
        this.$vs.notify({
          title: "Fehler",
          text: "Bitte Zeitraum von und bis angeben.",
          color: "danger",
        });
        return false;
      }
      const required = [
        { field: "categories", name: "Kategorie" },
        { field: "status", name: "Status" },
        { field: "title", name: "Überschrift" },
        { field: "offer", name: "Angebot" },
        { field: "description", name: "Beschreibung" },
        { field: "organizations", name: "Organisationen" },
        { field: "name1", name: "Anbieter Name-1" },
        { field: "dateFrom", name: "Zeitraum von" },
        { field: "dateTo", name: "Zeitraum bis" },
      ];
      for (const f of required) {
        const value = this.form[f.field];
        if (!value || (Array.isArray(value) && value.length === 0)) {
          this.$vs.notify({
            title: "Fehler",
            text: `${f.name} ist ein Pflichtfeld.`,
            color: "danger",
          });
          return false;
        }
      } // Zeitraum-Logik prüfen
      if (new Date(this.form.dateFrom) > new Date(this.form.dateTo)) {
        this.$vs.notify({
          title: "Fehler",
          text: "Zeitraum: 'von' darf nicht nach 'bis' liegen.",
          color: "danger",
        });
        return false;
      }

      // Formatprüfungen
      if (this.form.email && !/.+@.+\..+/.test(this.form.email)) {
        this.$vs.notify({
          title: "Fehler",
          text: "Bitte gültige E-Mail-Adresse eingeben.",
          color: "danger",
        });
        return false;
      }
      if (this.form.phone && !/^[0-9+\-()\s]+$/.test(this.form.phone)) {
        this.$vs.notify({
          title: "Fehler",
          text: "Bitte gültige Telefonnummer eingeben.",
          color: "danger",
        });
        return false;
      }
      if (this.form.website && !/^https?:\/\/.+\..+/.test(this.form.website)) {
        this.$vs.notify({
          title: "Fehler",
          text: "Bitte gültige URL angeben (https://...).",
          color: "danger",
        });
        return false;
      }
      if (this.form.shop && !/^https?:\/\/.+\..+/.test(this.form.shop)) {
        this.$vs.notify({
          title: "Fehler",
          text: "Bitte gültige URL für den Onlineshop angeben (https://...).",
          color: "danger",
        });
        return false;
      }

      return true;
    },
    async submitForm() {
      // Zeitraum: Datum + Uhrzeit kombinieren
      this.form.dateFrom = `${this.dateFromDate}T${this.dateFromTime}`;
      this.form.dateTo = `${this.dateToDate}T${this.dateToTime}`;

      if (!this.validateForm()) return;
      // Organisationen auflösen
      const orgs = this.form.organizations
        .map((id) => this.allOrganizationsList.find((o) => o.id === id))
        .filter(Boolean);

      const now = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
        now.getDate(),
      )}`;
      const currentUser = this.user?.username || "Unbekannt";

      // created_at / UpdatedAt nur Datum
      if (!this.form.id && !this.form.created_at) {
        this.form.created_at = today;
        this.form.createdBy = currentUser;
      }
      if (this.form.id) {
        this.form.updatedAt = today;
        this.form.updatedBy = currentUser;
      }

      // Zeitraum-String für Anzeige
      if (this.form.dateFrom && this.form.dateTo) {
        this.form.period = this.formatPeriod(
          this.form.dateFrom,
          this.form.dateTo,
        );
      }
      // Payload für API
      const payload = {
        customer_id: this.form.customer_id,
        status: this.form.status,
        code: this.form.code,
        categories: this.form.categories ? [this.form.categories] : null,
        start_at: this.form.dateFrom,
        end_at: this.form.dateTo,
        headline_text: this.form.title,
        image_id: this.form.image_id || null,
        description_text: this.form.description,
        discount_text: this.form.offer,
        email: this.form.email,
        phone_number: this.form.phone,
        website_url: this.form.website,
        shop_url: this.form.shop,
        address: {
          street_address: this.form.street || "",
          zip_code: this.form.zip_code || "",
          city: this.form.city || "",
          country: this.form.country || "", // optional, falls du ein Landfeld hast
          additional: this.form.name2 || "",
          name: this.form.name1 || "",
        },
        global: false,
      };

      let status;
      if (!this.form.id) {
        // Neuer Bonus
        status = await this.$store.dispatch("bonus/createBonus", payload);
        if (status === 201) {
          this.$vs.notify({ color: "success", title: "Bonus erstellt!" });

          // // Alle Boni laden
          // await this.$store.dispatch("bonus/loadBonuses");

          // // Den gerade erstellten Bonus anhand z.B. Code oder eindeutiger Felder finden
          // const newBonus = this.$store.getters["bonus/getBonuses"].find(
          //   (b) => b.code === payload.code
          // );

          // if (!newBonus) {
          //   this.$vs.notify({
          //     color: "danger",
          //     title: "Fehler beim Laden des Bonus",
          //   });
          //   return;
          // }

          // Organisationen mappen
          await this.$store.dispatch("bonus/addOrganisationToBonus", {
            bonusId: payload.id, // <- hier die echte ID verwenden
            organisationId: this.form.organizations,
          });
        } else {
          this.$vs.notify({ color: "danger", title: "Fehler beim Erstellen" });
          return;
        }
      } else {
        const Updatepayload = {
          id: this.form.id,
          customer_id: this.form.customer_id,
          status: this.form.status,
          code: this.form.code,
          categories: this.form.categories ? [this.form.categories] : null,
          start_at: this.form.dateFrom,
          end_at: this.form.dateTo,
          headline_text: this.form.title,
          image_id: this.form.image_id || null,
          description_text: this.form.description,
          discount_text: this.form.offer,
          email: this.form.email,
          phone_number: this.form.phone,
          website_url: this.form.website,
          shop_url: this.form.shop,
          address: {
            street_address: this.form.street || "",
            zip_code: this.form.zip_code || "",
            city: this.form.city || "",
            country: this.form.country || "",
            additional: this.form.name2 || "",
            name: this.form.name1 || "",
          },
          global: false,
        };
        //Organisationen

        await this.$store.dispatch("bonus/addOrganisationToBonus", {
          bonusId: this.form.id, // <- hier die echte ID verwenden
          organisationId: this.form.organizations,
        });

        // Bestehender Bonus
        status = await this.$store.dispatch("bonus/updateBonus", Updatepayload);
        if (status === 200) {
          this.$vs.notify({ color: "success", title: "Bonus gespeichert!" });
        } else {
          this.$vs.notify({ color: "danger", title: "Fehler beim Speichern" });
          return;
        }
      }

      // Bonus lokal updaten
      Object.assign(this.bonus, payload);
      if (this.previewImage) {
        this.bonus.previewImage = this.previewImage;
      } else {
        this.bonus.previewImage = "/icons/Photo.svg";
      }
      // Bearbeitungsmodus schließen
      this.isEditing = false;
    },

    cancelEdit() {
      if (!this.form.id) this.handleClose();
      else {
        this.isEditing = false;
      }
    },

    async deleteBonus() {
      if (!this.form.id) return;

      // Bestätigungsdialog
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Löschen bestätigen",
        text: "Wollen Sie wirklich diesen Bonus löschen?",
        accept: async () => {
          const status = await this.$store.dispatch(
            "bonus/deleteBonus",
            this.form.id,
          );
          if (status === 200) {
            this.$vs.notify({
              color: "success",
              title: "Bonus wurde gelöscht",
            });
          } else {
            this.$vs.notify({ color: "danger", title: "Fehler beim Löschen" });
          }
          this.handleClose();
        },
        cancelText: "Abbrechen",
        acceptText: "Löschen",
      });
    },
    handleClose() {
      this.$emit("update:showPopup", false); // synced mit parent
      this.$emit("close"); // optional für Externe, die @close hören
    },

    toLocalISOString(date) {
      const pad = (n) => String(n).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate(),
      )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },

    formatPeriod(from, to) {
      if (!from || !to) return "";

      const f = new Date(from),
        t = new Date(to),
        pad = (n) => String(n).padStart(2, "0");

      const formatDate = (d) =>
        `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
      const formatTime = (d) =>
        `${pad(d.getHours())}:${pad(d.getMinutes())} Uhr`;

      return `${formatDate(f)} ${formatTime(f)} – ${formatDate(t)} ${formatTime(
        t,
      )}`;
    },
    getPeriodPart(part) {
      const p = this.formatPeriod(
        this.bonus?.dateFrom,
        this.bonus?.dateTo,
      ).split(" – ");
      return part === "from" ? p[0] || "" : p[1] || "";
    },

    formatTimestamp(ts) {
      if (!ts) return "";

      const d = new Date(ts),
        pad = (n) => String(n).padStart(2, "0");

      return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
    },

    openOrgPopup() {
      this.tempSelectedOrgs = [...this.form.organizations];
      this.orgPopupActive = true;
    },

    applyOrganizations() {
      // Finde nur die IDs, die neu sind
      const newOrgs = this.tempSelectedOrgs.filter(
        (orgId) => !this.form.organizations.includes(orgId),
      );

      // form.organizations aktualisieren
      this.form.organizations = [...this.form.organizations, ...newOrgs];

      // nur neue Orgs ins Backend schicken
      // if (this.form.id)
      //   for (const orgId of newOrgs) {
      //     this.$store.dispatch("bonus/addOrganisationToBonus", {
      //       bonusId: this.form.id,
      //       organisationId: orgId,
      //     });
      //   }

      this.closeOrgPopup();
    },

    removeOrganization(orgId) {
      this.form.organizations = this.form.organizations.filter(
        (id) => id !== orgId,
      );
    },
    toggleShowAllOrgs() {
      this.showAllOrgs = !this.showAllOrgs;
    },
    toggleAll() {
      if (this.selectAll) {
        // Alles auswählen
        this.tempSelectedOrgs = this.allOrganizationsList.map((o) => o.id);
      } else {
        // Alles abwählen
        this.tempSelectedOrgs = [];
      }
    },
    getOrgName(id) {
      const org = this.allOrganizationsList.find((o) => o.id === id);
      return org ? org.name : id;
    },
    toggleOrgPopup() {
      this.tempSelectedOrgs = [...this.form.organizations];
      this.orgPopupActive = !this.orgPopupActive;
    },
    closeOrgPopup() {
      this.form.organizations = [...this.tempSelectedOrgs];
      this.orgPopupActive = false;
    },
  },
};
</script>

<style scoped>
.bonus-detail {
  display: flex;
  flex-direction: column;
}
.bonus-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: #f2f2f2;
  border-radius: 12px;
  padding: 15px;
  margin-bottom: 1.5rem;
}
.row-two-columns {
  display: flex;
  gap: 0.5rem;
}
.passport-img {
  width: 100%;
  border-radius: 10px;
}
.popup-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}
.input-with-label label {
  font-size: 11px;
  color: #999;
  display: block;
  padding-left: 5px;
  margin-bottom: 2px;
}
.full-width {
  width: 100%;
  white-space: pre-line;
}

.detail-section {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px 15px;
  margin-bottom: 1rem;
  background-color: #fafafa;
}
.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 5px;
}

.vs-input--input[type="time"] + .vs-input--icon {
  right: 10px !important;
  left: auto !important;
}

.period {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.period-row {
  display: flex;
}

.period-row-horizontal {
  display: flex;
  gap: 1.5rem;
  margin-top: 0.25rem;
  flex-wrap: wrap; /* falls Platz nicht reicht, geht es in nächste Zeile */
}
.period-item {
  align-items: center;
}

.period-item .label {
  font-weight: 600;
  width: 30px; /* gleiche Breite für „Von“ / „Bis“ */
}

.period-item .value {
  flex: 1;
  margin-left: 5px;
}
.period-row .label {
  width: 30px; /* feste Breite für "Von" / "Bis" */
  font-weight: 500;
}

.period-row .value {
  flex: 1; /* Datum + Uhrzeit */
}
.period-from,
.period-to {
  font-size: 0.95rem;
}
.border {
  border: 1px solid rgb(200, 200, 200) !important;
} /* --- Organisationen UI --- */
.org-select {
  position: relative;
  display: block;
}
.org-select .vs-input--content {
  /* sorgt für Platz rechts für den Button */
  padding-right: 44px;
}
.org-list {
  max-height: 420px;
  overflow-y: auto;
  padding: 10px;
}
.org-list-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.column-scroll {
  max-height: 650px;
  overflow-y: auto;
}

.img-container {
  position: relative;
  padding: 5px;
  border-radius: 10px;
  justify-content: center;
  display: flex;
  align-items: center;
  height: auto;
  width: auto;
  margin: 20px;
  border: 3px solid #cccccc;
}
.img-close {
  position: absolute;
  top: 7px;
  right: 7px;
  background: #b40000;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  cursor: pointer;
  padding: 0;
}

.chip {
  background-color: #005a9b3e;
  border-radius: 16px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
}
.chip-close {
  border: none;
  background: none;
  cursor: pointer;
  margin-left: 4px;
}
.show-more-btn {
  margin-left: 5px;
}
.org-input-field {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 6.4px 6.4px;
  background-color: #fff;
  position: relative;
  min-height: 45px;
  box-sizing: border-box;
}

.chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  flex: 1;
  max-height: 70px; /* Höhe für 2-3 Zeilen */
  overflow: hidden;
}

.more-chip {
  cursor: pointer;
  color: #555;
  font-size: 0.85rem;
  padding: 2px 6px;
  border-radius: 12px;
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
}

.org-popover {
  position: absolute;
  top: 40px;
  right: 0;
  min-width: 467px;
  max-width: 500px;
  width: auto;
  white-space: nowrap;
  max-height: 300px;
  min-height: 45px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 8px;
  z-index: 2000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.popover-footer {
  text-align: right;
  margin-top: 6px;
  color: white;
}

/* Kopfbereich */
.bonus-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
}
.org-popover .mb,
.org-popover .org-list-item {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* Text linksbündig */
  gap: 8px;
}

.header-left {
  flex: 1 1 60%;
}

.bonus-title {
  font-size: 2rem;
  font-weight: 600;
  margin: 0 0 0.5rem;
}

.bonus-offer {
  font-size: 1.2rem;
  color: #555;
  margin: 0 0 0.5rem;
}

.chips-row {
  display: flex;
  gap: 0.5rem;
  padding-bottom: 10px;
}

.chip.status.paused {
  background: #f8d7da;
  color: #991b1b;
}
.chip.status.active {
  background: #d4edda;
  color: #065f46;
}
.chip.status.archived {
  background-color: #fef3c7;
  color: #78350f;
}

.chip.category {
  background: #e0e7ff;
  color: #004085;
}

.header-right {
  flex-shrink: 0;
}

.bonus-image {
  width: 200px;
  height: 200px;
  object-fit: contain;
  border-radius: 10px;
  border: 1px solid #f2f2f2;
}

/* Zeitraum & Organisationen */
.meta-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-top: 1rem;
}

.meta-item {
  flex: 1 1 45%;
  font-size: 0.95rem;
}

.chips.org-chip {
  background: #ffeeba;
  color: #856404;
}

/* Anbieterinfos */
.anbieter-list {
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0;
}

.anbieter-list li {
  margin: 0.25rem 0;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.95rem;
}

/* Footer */
.bonus-footer {
  margin-top: 2rem;
  display: flex;
  justify-content: flex-end; /* <-- hier ändern */
  align-items: center;
  gap: 0.5rem;
}

.meta-info {
  font-size: 0.75rem;
  color: #777777;
  line-height: 1.3;
}

.action-buttons {
  display: flex;
  gap: 0.5rem;
}

/* Responsive */
@media (max-width: 768px) {
  .bonus-header {
    flex-direction: column;
  }

  .header-right {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .bonus-image {
    width: 100%;
    max-width: 280px;
    height: auto;
  }

  .meta-grid {
    flex-direction: column;
  }

  .meta-item {
    flex: 1 1 100%;
  }
}
.adress_input {
  display: flex;
  margin-top: -17px;
  margin-bottom: 19px;
}
</style>
